var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: {
              propsData: {
                isCountry: false,
                adChannel: false,
                adPlacement: false,
                isDate: false
              }
            },
            on: { searchChange: _vm.searchChange }
          }),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-date-picker", {
                attrs: {
                  "picker-options": _vm.pickerOptionsRadius,
                  "value-format": "timestamp",
                  type: "datetimerange",
                  "start-placeholder": _vm.$t("startTime"),
                  "end-placeholder": _vm.$t("endTime")
                },
                model: {
                  value: _vm.PointTime,
                  callback: function($$v) {
                    _vm.PointTime = $$v
                  },
                  expression: "PointTime"
                }
              })
            ],
            1
          ),
          _vm.rawData.game_mark.indexOf("yjfm") == -1
            ? [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          filterable: "",
                          placeholder: _vm.$t("pleaseChoose")
                        },
                        on: { change: _vm.getServer },
                        model: {
                          value: _vm.paramsData.is_prod,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "is_prod", $$v)
                          },
                          expression: "paramsData.is_prod"
                        }
                      },
                      _vm._l(_vm.severlist, function(item) {
                        return _c("el-option", {
                          key: item.label,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: _vm.$t("pleaseSelectServer")
                        },
                        model: {
                          value: _vm.paramsData.server_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "server_id", $$v)
                          },
                          expression: "paramsData.server_id"
                        }
                      },
                      _vm._l(_vm.serverList, function(item) {
                        return _c("el-option", {
                          key: item.serverID,
                          attrs: {
                            label: item.serverName,
                            value: item.serverID
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: _vm.$t("chatType") },
                        on: { change: _vm.groupChange },
                        model: {
                          value: _vm.searchData.is_group,
                          callback: function($$v) {
                            _vm.$set(_vm.searchData, "is_group", $$v)
                          },
                          expression: "searchData.is_group"
                        }
                      },
                      _vm._l(_vm.hdchartTypeArr, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm.searchData.is_group == "3"
                  ? _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: _vm.$t("senderUserId") },
                          model: {
                            value: _vm.searchData.user_id,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "user_id", $$v)
                            },
                            expression: "searchData.user_id"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.searchData.is_group == "3"
                  ? _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: _vm.$t("receiverUserId") },
                          model: {
                            value: _vm.searchData.to_user_id,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "to_user_id", $$v)
                            },
                            expression: "searchData.to_user_id"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          filterable: "",
                          placeholder: _vm.$t("pleaseChoose")
                        },
                        on: { change: _vm.envIdChange },
                        model: {
                          value: _vm.paramsData.env_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "env_id", $$v)
                          },
                          expression: "paramsData.env_id"
                        }
                      },
                      _vm._l(_vm.szgmEnv, function(item) {
                        return _c("el-option", {
                          key: item.label,
                          attrs: { label: item.label, value: item.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: _vm.$t("serverChannel")
                        },
                        on: { change: _vm.serverChange },
                        model: {
                          value: _vm.server_channel,
                          callback: function($$v) {
                            _vm.server_channel = $$v
                          },
                          expression: "server_channel"
                        }
                      },
                      _vm._l(_vm.serverChannel, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: _vm.$t("showTestServer")
                        },
                        on: { change: _vm.serverChannelChange },
                        model: {
                          value: _vm.show_test,
                          callback: function($$v) {
                            _vm.show_test = $$v
                          },
                          expression: "show_test"
                        }
                      },
                      _vm._l(_vm.serverType, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          multiple: "",
                          filterable: "",
                          clearable: "",
                          "collapse-tags": "",
                          placeholder: _vm.$t("server")
                        },
                        on: { change: _vm.severChange },
                        model: {
                          value: _vm.paramsData.server_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "server_id", $$v)
                          },
                          expression: "paramsData.server_id"
                        }
                      },
                      _vm._l(_vm.serverListYJ, function(item) {
                        return _c("el-option", {
                          key: item.serverID,
                          attrs: {
                            label: item.serverName,
                            value: item.serverID
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: _vm.$t("chatType") },
                        on: { change: _vm.groupChange },
                        model: {
                          value: _vm.searchData.is_group,
                          callback: function($$v) {
                            _vm.$set(_vm.searchData, "is_group", $$v)
                          },
                          expression: "searchData.is_group"
                        }
                      },
                      _vm._l(_vm.chartTypeArr, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm.searchData.is_group == "2"
                  ? _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: _vm.$t("senderUserId") },
                          model: {
                            value: _vm.searchData.user_id,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "user_id", $$v)
                            },
                            expression: "searchData.user_id"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.searchData.is_group == "2"
                  ? _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: _vm.$t("receiverUserId") },
                          model: {
                            value: _vm.searchData.to_user_id,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "to_user_id", $$v)
                            },
                            expression: "searchData.to_user_id"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.searchData.is_group == "1"
                  ? _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              multiple: "",
                              "collapse-tags": "",
                              clearable: "",
                              filterable: "",
                              placeholder: _vm.$t("group")
                            },
                            model: {
                              value: _vm.searchData.to_group_id,
                              callback: function($$v) {
                                _vm.$set(_vm.searchData, "to_group_id", $$v)
                              },
                              expression: "searchData.to_group_id"
                            }
                          },
                          _vm._l(_vm.groupList, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item, value: item }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
        ],
        2
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.tableData.length },
                  on: { click: _vm.exportdata }
                },
                [_vm._v(_vm._s(_vm.$t("export")))]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.searchClick(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "cards" }, [
        _vm.tableData.length
          ? _c(
              "div",
              { staticClass: "chatHistory", attrs: { id: "scrollContainer" } },
              [
                _vm.rawData.game_mark.indexOf("yjfm") == -1
                  ? _vm._l(_vm.tableData, function(item, index) {
                      return _c("div", { staticClass: " chatMonitorItem" }, [
                        _c(
                          "div",
                          { staticClass: "x-start chatMonitorItem-title" },
                          [
                            _c("div", { staticClass: "flex align-end " }, [
                              _c(
                                "div",
                                { staticClass: "chatMonitorItem-userID" },
                                [_vm._v(_vm._s(item.server_id) + " : ")]
                              ),
                              _c(
                                "div",
                                { staticClass: "chatMonitorItem-name" },
                                [_vm._v(_vm._s(item.role_name))]
                              ),
                              _c(
                                "div",
                                { staticClass: "chatMonitorItem-userID" },
                                [_vm._v(_vm._s(item.role_id))]
                              ),
                              _vm.searchDis_group != "3"
                                ? _c(
                                    "div",
                                    { staticClass: "chatMonitorItem-time" },
                                    [_vm._v(_vm._s(item.time))]
                                  )
                                : _vm._e()
                            ]),
                            _vm.searchDis_group == "3"
                              ? _c("div", { staticClass: "middle" }, [
                                  _vm._v(" " + _vm._s(_vm.$t("sendTo")) + " ")
                                ])
                              : _vm._e(),
                            _vm.searchDis_group == "3"
                              ? _c("div", { staticClass: "flex align-end " }, [
                                  _c(
                                    "div",
                                    { staticClass: "chatMonitorItem-name" },
                                    [_vm._v(_vm._s(item.to_role_name))]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "chatMonitorItem-userID" },
                                    [_vm._v(_vm._s(item.to_role_id))]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "chatMonitorItem-time" },
                                    [_vm._v(_vm._s(item.time))]
                                  )
                                ])
                              : _vm._e()
                          ]
                        ),
                        _c("div", { staticClass: "chatMonitorItem-content" }, [
                          _vm._v(" " + _vm._s(item.content) + " ")
                        ])
                      ])
                    })
                  : _vm._l(_vm.tableData, function(item, index) {
                      return _c("div", { staticClass: " chatMonitorItem" }, [
                        _c(
                          "div",
                          { staticClass: "x-start chatMonitorItem-title" },
                          [
                            _c("div", { staticClass: "flex align-end " }, [
                              _c(
                                "div",
                                { staticClass: "chatMonitorItem-userID" },
                                [_vm._v(_vm._s(item.server_id) + " : ")]
                              ),
                              _c(
                                "div",
                                { staticClass: "chatMonitorItem-name" },
                                [_vm._v(_vm._s(item.role_name))]
                              ),
                              _c(
                                "div",
                                { staticClass: "chatMonitorItem-userID" },
                                [_vm._v(_vm._s(item.role_id))]
                              ),
                              _vm.searchDis_group == "1" ||
                              _vm.searchDis_group == "3"
                                ? _c(
                                    "div",
                                    { staticClass: "chatMonitorItem-time" },
                                    [_vm._v(_vm._s(item.time))]
                                  )
                                : _vm._e()
                            ]),
                            _vm.searchDis_group == "2"
                              ? _c("div", { staticClass: "middle" }, [
                                  _vm._v(" " + _vm._s(_vm.$t("sendTo")) + " ")
                                ])
                              : _vm._e(),
                            _vm.searchDis_group == "2"
                              ? _c("div", { staticClass: "flex align-end " }, [
                                  _c(
                                    "div",
                                    { staticClass: "chatMonitorItem-name" },
                                    [_vm._v(_vm._s(item.to_role_name))]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "chatMonitorItem-userID" },
                                    [_vm._v(_vm._s(item.to_role_id))]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "chatMonitorItem-time" },
                                    [_vm._v(_vm._s(item.time))]
                                  )
                                ])
                              : _vm._e()
                          ]
                        ),
                        _c("div", { staticClass: "chatMonitorItem-content" }, [
                          _vm._v(" " + _vm._s(item.content) + " ")
                        ])
                      ])
                    })
              ],
              2
            )
          : _c("div", { staticClass: "x-c notfound1B" }, [
              _c("img", {
                staticClass: "notfound1",
                attrs: { src: require("../../assets/notfound1.png"), alt: "" }
              })
            ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }